import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import React from 'react'

const browserHistory = createBrowserHistory({ basename: '' })
const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: '384faeed-ff64-4125-9a56-506587d12c3f',
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
})
appInsights.loadAppInsights()

// The public result viewer is /r/<token>, and the token is a bearer credential
// for one patient's study. The React plugin auto-tracks page-view URIs, so
// without this every link handed to PointClickCare would be shipped to App
// Insights and sit there for its retention period.
//
// Rewritten rather than dropped: knowing the viewer was opened is useful, knowing
// which link was used is not worth storing. Covers url/refUri/name on every
// telemetry type, since a later navigation carries the viewer URL as the referrer.
const VIEWER_PATH = /\/r\/[^/?#]+/g

const redactViewerToken = (value: unknown): string | undefined =>
  typeof value === 'string' && value.includes('/r/')
    ? value.replace(VIEWER_PATH, '/r/[redacted]')
    : undefined

appInsights.addTelemetryInitializer(item => {
  const scrub = (target: any, key: string) => {
    const redacted = redactViewerToken(target?.[key])
    if (redacted !== undefined) target[key] = redacted
  }

  scrub(item, 'name')
  scrub(item.baseData ?? {}, 'uri')
  scrub(item.baseData ?? {}, 'refUri')
  scrub(item.baseData ?? {}, 'name')
  scrub(item.ext?.trace ?? {}, 'name')
})

/**
 * Component wrapper with AI tracking and component name
 * @param Component
 * @param componentName
 * @returns
 */
const ComponentWrapperWithAITracking = (
  Component: React.ComponentType<any>,
  componentName: string,
) => withAITracking<any>(reactPlugin, Component, componentName, 'appInsights')

export { reactPlugin, appInsights, ComponentWrapperWithAITracking }
